<!--
 * @Author: ken yang
 * @Date: 2022-10-31 19:17:43
 * @LastEditTime: 2023-03-09 09:39:13
 * @LastEditors: ken yang
 * @Description: i18n插槽
 * @FilePath: /uexch_pc/src/components/widget/i18n.vue
-->
<template>
  <div>
    <span v-for="(item,index) in arr" :key="index">
      <!-- <span name="share" /> -->
      <slot v-if="item.key" :name="item.key" />
      <slot v-else>{{ item }}</slot>
    </span>
    <!-- <slot name="share" /> -->
  </div>
</template>
<script setup>

const props = defineProps({
  path: {
    require: true
  }
})

const arr = $computed(() => {
  const arr = $ref([])
  try {
    const lang = $t.curLang()
    const curSentence = props.path.split('.').reduce((o, i) => {
      if (o) return o[i]
    }, lang)

    // 容错处理：如果翻译不存在，返回原路径
    if (!curSentence || typeof curSentence !== 'string') {
      arr.push(props.path)
      return arr
    }

    const reg = /\{.*?\}/g
    const sentences = curSentence.split(reg)
    const keys = curSentence.match(reg)

  sentences.forEach((element, index) => {
    arr.push(element)
    if (keys[index])arr.push({ key: keys[index].replace(/{|}/g, '') })
  })
    return arr
  } catch (error) {
    // 容错处理：发生任何错误时返回原路径
    console.error('i18n component error:', error)
    return [props.path]
  }
})

</script>
<style lang="scss">
</style>
